import styled from 'styled-components';

export default styled.div`
  margin-right: -16px;
  margin-left: -16px;
  display: grid;
`;
